import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Dimensions,  ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

import { RellenoCatalogoModel } from '../../models/ingrediente/ingrediente.model';
import { IngredienteService } from '../../services/ingrediente.service';


@Component({
  selector: 'app-ingrediente-relleno-dialog',
  templateUrl: './ingrediente-relleno-dialog.component.html',
  styleUrls: ['./ingrediente-relleno-dialog.component.css']
})
export class IngredienteRellenoDialogComponent implements OnInit {

  formulario: UntypedFormGroup;
  submitted = false;
  ingredientemodel: RellenoCatalogoModel;
  verImagenes: boolean;

  constructor(public dialogRef: MatDialogRef<IngredienteRellenoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: UntypedFormBuilder,
              private ingredienteService: IngredienteService) { }

    // imageCropper
    imageChangedEvent: any = '';
    croppedImage: any = '';

  ngOnInit(): void {
      this.verImagenes = false;
      this.formulario = this.formBuilder.group({
      //  cobertura: ['', Validators.required],
          relleno: ['', Validators.required]
      }, {
      });
    //  this.ingredientemodel.idcobertura = 0;
      this.ingredientemodel = new RellenoCatalogoModel();
      if (this.data.row.idrelleno > 0) {
        this.verImagenes = true;
        this.ingredientemodel = this.data.row;
      }
  }

  // variable para acceder a los campos del formulario
  get f() { return this.formulario.controls; }

  get rellenoNoValido() {
    return this.formulario.get('relleno').invalid;
  }

  abcCatRelleno() {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Guardando registro ...'
    });
    Swal.showLoading();
    this.ingredientemodel.operacion = this.ingredientemodel.idrelleno > 0 ? 2 : 1;
    this.ingredientemodel.idusuario = Number(sessionStorage.getItem('idu'));

    console.log(this.ingredientemodel);
    this.ingredienteService.abcCatRellenos(this.ingredientemodel).subscribe( (resp: any[]) => {
        Swal.close();
        if (this.ingredientemodel.operacion === 1) {
          this.ingredientemodel.idrelleno = resp['idrespuesta'] !== -1 || resp['idrespuesta'] !== -2 ? resp['idrespuesta'] : 0 ;
          this.ingredientemodel.operacion = this.ingredientemodel.operacion === 1 ? 2 : 2;
        }
        if (resp) {
          if (resp['idrespuesta'] > 0) {
            Swal.fire({
              icon: 'success',
              text: resp['respuesta'],
              confirmButtonColor: '#391410',
              confirmButtonText: 'ACEPTAR'
            });
           } else {
            Swal.fire({
              icon: 'error',
              text: resp['respuesta'],
              confirmButtonColor: '#391410',
              confirmButtonText: 'ACEPTAR'
            });
           }
        }
        }, (err) => {
         Swal.close();
         switch (err.status) {
          case 0:
              Swal.fire({
                icon: 'warning',
                text: 'No hay conexión con el servidor o revise su conexión a internet.',
                confirmButtonColor: '#391410',
                confirmButtonText: 'ACEPTAR'
              });
              break;
           case 409:
             Swal.fire({
              icon: 'error',
              text: 'Error ' + err.status + ' en el guardado del catálogo de rellenos.',
              confirmButtonColor: '#391410',
              confirmButtonText: 'ACEPTAR'
             });
             break;
            case 500:
                Swal.fire({
                  icon: 'error',
                  text: 'Error ' + err.status + ' en el guardado del catálogo de rellenos.',
                  confirmButtonColor: '#391410',
                  confirmButtonText: 'ACEPTAR'
                });
                break;
          }
        });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {

    this.submitted = true;

    // se detiene si el formulario es invalido
    if (this.formulario.invalid) {
        return;
    }
    this.abcCatRelleno();

    // valores visibles del formmulario
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
    // valores del modelo que se pasa al abc
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.extrasmodel, null, 4));

  }

  fileChangeEvent(event1: any): void {
    this.imageChangedEvent = event1;
  }

  imageCropped(event1: ImageCroppedEvent) {
    this.croppedImage = event1.base64;
    this.ingredientemodel.imagenb64 = this.croppedImage;
  }

  imageLoaded() {
    // show cropper
    // tslint:disable-next-line: deprecation
  //  event = null;
  }

  cropperReady() {
    // cropper ready
    // this.productomodel.imagenb64 = this.croppedImage;
    // console.log("principal");
    // console.log(this.productomodel.imagenb64);
  }

  loadImageFailed() {
    // show message
  }

}
